module.exports = __webpack_public_path__ + "img/icon-more.83b19bd2.svg";